<section id="products-profile">

    <app-header class="offers--active products--active"></app-header>
    
    <div class="page">
        <span class="wave-decoration"></span>
        <div class="box-title">
            <div class="container">
                <h1 class="title-one">Publica tu inmueble</h1>
                <p class="title-description">Conoce nuestros productos y todos sus beneficios.</p>
            </div>
        </div>
        <div class="container container-profile">
            <h2 class="title-two"><span class="icon material-icons">person_outline</span>Nos ajustamos a tu necesidad</h2>

            <p class="secondary-description">Selecciona tu perfil y accede a los planes que tenemos para promocionar inmuebles y proyectos.</p>
            <div class="grid profiles-box">
                <button name="inmobiliaria" class="grid-3 btn-profile" type="button" [ngClass]="{ 'btn-profile--active' : isValue == 1 }" (click)="selectProfile(1, 'inmobiliaria')" onclick="dataLayer.push({ 'event': 'elegir_tipo_usuario’,’tipo de usuario’:’según la elección'});">
                <picture class="btn-profile__image">
                    <source media="(max-width: 640px)" srcset="./assets/images/products/inmobiliaria-mobile.png">
                    <source media="(min-width: 641px)" srcset="./assets/images/products/inmobiliaria.png">
                    <img src="./assets/images/products/inmobiliaria.png" alt="inmobiliarias">
                </picture>
                Inmobiliaria
                <span class="btn-profile__description">Asesoro la compra, venta o arriendo de inmuebles.</span>
                </button>
                <button name="agente" class="grid-3 btn-profile" type="button" [ngClass]="{ 'btn-profile--active' : isValue == 2 }" (click)="selectProfile(2, 'agente')" onclick="dataLayer.push({ 'event': 'elegir_tipo_usuario’,’tipo de usuario’:’según la elección'});">
                <picture class="btn-profile__image">
                    <source media="(max-width: 640px)" srcset="./assets/images/products/agenteinmobiliario-mobile.png">
                    <source media="(min-width: 641px)" srcset="./assets/images/products/agenteinmobiliario.png">
                    <img src="./assets/images/products/agenteinmobiliario.png" alt="agentes independientes">
                </picture>
                <span class="d-sm-block d-none">Agente inmobiliario</span>  
                <span class="d-block d-sm-none">Agentes</span>  

                <span class="btn-profile__description">Promociono la compra, venta o arriendo de inmuebles.</span>
                </button>
                <button name="constructora" class="grid-3 btn-profile" type="button" [ngClass]="{ 'btn-profile--active' : isValue == 3 }" (click)="selectProfile(3, 'constructora')" onclick="dataLayer.push({ 'event': 'elegir_tipo_usuario’,’tipo de usuario’:’según la elección'});">
                <picture class="btn-profile__image">
                    <source media="(max-width: 640px)" srcset="./assets/images/products/constructora-mobile.png">
                    <source media="(min-width: 641px)" srcset="./assets/images/products/constructora.png">
                    <img src="./assets/images/products/constructora.png" alt="Constructoras">
                </picture>
                Constructora
                <span class="btn-profile__description">Construyo y vendo proyectos de vivienda.</span>
                </button>
                <button name="persona" class="grid-3 btn-profile" type="button" [ngClass]="{ 'btn-profile--active' : isValue == 4 }" (click)="selectProfile(4, 'persona'); selectPlanType(2, 'tu plan', 'ver planes')" onclick="dataLayer.push({ 'event': 'elegir_tipo_usuario’,’tipo de usuario’:’según la elección'});">
                <picture class="btn-profile__image">
                    <source media="(max-width: 640px)" srcset="./assets/images/products/propietario-mobile.png">
                    <source media="(min-width: 641px)" srcset="./assets/images/products/propietario.png">
                    <img src="./assets/images/products/propietario.png" alt="clientes">
                </picture>
                Propietario
                <span class="btn-profile__description">Estoy vendiendo o arrendando mi inmueble.</span>
                </button>
            </div>
        </div>
        <div class="curve-top--left py-medium">
            <div class="container">
                <h2 class="title-two m-none" *ngIf="isValue === 4 && hideCardIsPN"><span class="icon material-icons">star_border</span>Escoge un plan o arma el tuyo</h2>
                <h2 class="title-two m-none" *ngIf="isValue === 1 || isValue === 2  || isValue === 3"><span class="icon material-icons">star_border</span>Escoge un plan </h2>
                <p class="secondary-description">Tenemos diferentes opciones perfectas para ti.</p>
                <div class="plans-box">

                    <div class="card-item bg-gradient-blue-2 d-none" >
                        <a class="card-item__link" routerLink="/arma-tu-plan" (click)="selectPlanType(1, 'arma tu plan', 'quiero armarlo')"></a>
                        <div class="card-item__body">
                            <picture class="image">
                                <source media="(max-width: 640px)" srcset="./assets/images/products/build-plan-mobile.png">
                                <source media="(min-width: 641px)" srcset="./assets/images/products/build-plan.png">
                                <img class="image" src="./assets/images/products/build-plan.png" alt="armar plan">
                            </picture>
                            <div class="info">
                                <h3 class="info__title">Arma tu plan</h3>
                                <p class="info__description">Conoce los productos que tenemos para tus inmuebles y arma un plan a tu gusto. </p>
                            </div>
                        </div>
                        <span class="card-item__type d-flex">Quiero armarlo<span class="arrow material-icons">keyboard_arrow_right</span></span>
                    </div>

                    <div class="card-item bg-gradient-green-1" *ngIf="isValue === 1 || isValue === 2 || isValue === 3 ">
                        <a class="card-item__link" routerLink="/seleccion-ideal" (click)="selectPlanType(2, 'tu plan', 'ver planes')"></a>
                        <div class="card-item__body">
                            <picture class="image">
                                <source media="(max-width: 640px)" srcset="./assets/images/products/view-plan-mobile.png">
                                <source media="(min-width: 641px)" srcset="./assets/images/products/view-plan.png">
                                <img class="image" src="./assets/images/products/view-plan.png" alt="ver plan">
                            </picture>
                            <div class="info">
                                <h3 class="info__title">Tu plan</h3>
                                <p class="info__description" *ngIf="isValue === 1 || isValue === 2">Pensamos en tus necesidades y creamos planes a tu medida, selecciona el tuyo. </p>
                                <p class="info__description" *ngIf="isValue === 3 ">En Ciencuadras pensamos en tus necesidades, por eso puedes elegir el plan ideal para tu negocio. </p>

                            </div>
                        </div>
                        <span class="card-item__type d-flex">ver planes<span class="arrow material-icons">keyboard_arrow_right</span></span>
                    </div>

                    <div class="card-item bg-gradient-blue-3" *ngIf="isValue === 4 && hideCardIsPN">
                        <a class="card-item__link" (click)="setDataLayerPerson()" href={{urlPublicaTuMismo}}  ></a>
                        <div class="card-item__body">
                            <picture class="image">
                                <source media="(max-width: 640px)" srcset="./assets/images/products/publish-plan-mobile.png">
                                <source media="(min-width: 641px)" srcset="./assets/images/products/publica-tu-mismo.png">
                                <img class="image" src="../../../assets/images/products/publica-tu-mismo.png" alt="ver plan">
                            </picture>
                            <div class="info">
                                <h3 class="info__title">Publica tú mismo</h3>
                                <p class="info__description">Elige uno de nuestros planes y promociona tu inmueble en menor tiempo.</p>
                            </div>
                        </div>
                        <span class="card-item__type d-flex d-md-none">Publica tú mismo<span class="arrow material-icons">keyboard_arrow_right</span></span>
                        <span class="card-item__type d-none d-md-flex">PUBLICA TÚ MISMO<span class="arrow material-icons">keyboard_arrow_right</span></span>
                    </div>



                </div>
            </div>
        </div>
    </div>
    <lib-cc-footer [ccEnvironment]="ccEnvironment"></lib-cc-footer>
</section>